import '@vaadin/tooltip/theme/lumo/vaadin-tooltip.js';
import './vaadin-avatar-styles.js';
import '../../src/vaadin-avatar.js';
